import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BADGE
\*------------------------------------ */
/**
 * 1) Badges are blocks of color with text inside used for messaging
 */
.cat-c-badge {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  line-height: calc(var(--size-base-unit) * 1.625);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--cat-theme-color-badge-blue-background);
  color: var(--cat-theme-color-content-default);
  padding: calc(var(--size-base-unit) * 0.6875) calc(var(--size-base-unit) * 1.0625);
  border-radius: calc(var(--size-base-unit) * 2);
  min-width: calc(var(--size-base-unit) * 3);
  min-height: calc(var(--size-base-unit) * 3);
  /**
   * Dot badge
   */
  /**
  * Loader
  */
}
.cat-c-badge:not(.cat-is-dot) {
  max-width: var(--cat-badge-label-width, 275px);
}
.cat-c-badge.cat-c-badge--sm {
  line-height: calc(var(--size-base-unit) * 1.625);
  padding: calc(var(--size-base-unit) * 0.1875) calc(var(--size-base-unit) * 0.5625);
  min-height: calc(var(--size-base-unit) * 2);
  min-width: calc(var(--size-base-unit) * 2);
  overflow: hidden;
}
.cat-c-badge.cat-is-dot {
  padding: 0;
  border-radius: calc(var(--size-base-unit) * 1);
  min-width: calc(var(--size-base-unit) * 1);
  min-height: calc(var(--size-base-unit) * 1);
  border: none;
  background: var(--cat-theme-badge-dot-background, var(--cat-theme-color-badge-blue-background));
}
.cat-c-badge.cat-is-loading:not(.cat-is-dot) {
  background: none;
  padding: 0;
  height: 0;
  border-radius: unset;
}
.cat-c-badge.cat-is-loading.cat-is-dot {
  background: var(--cat-theme-color-background-subtle);
}
.cat-c-badge.cat-is-loading:not(.cat-c-badge--sm, .cat-is-dot) {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 1.5);
}

.cat-is-dot.cat-is-loading + .cat-dot-loader {
  display: inline-flex;
  position: relative;
  inset-block-start: calc(var(--size-base-unit) * 0.375);
}

/**
 * Blue badge
 */
.cat-c-badge--blue {
  background: var(--cat-theme-color-badge-blue-background);
  --cat-theme-badge-dot-background: var(--cat-theme-color-content-data);
}

/**
 * Green badge
 */
.cat-c-badge--green {
  background: var(--cat-theme-color-badge-green-background);
  --cat-theme-badge-dot-background: var(--cat-theme-color-badge-green-background);
}

/**
 * Grey badge
 */
.cat-c-badge--grey {
  background: var(--cat-theme-color-badge-grey-background);
  --cat-theme-badge-dot-background: var(--cat-theme-color-badge-grey-background);
}

/**
 * Yellow badge
 */
.cat-c-badge--yellow {
  background: var(--cat-theme-color-badge-yellow-background);
  --cat-theme-badge-dot-background: var(--cat-theme-color-badge-yellow-background);
}

/**
 * brand badge
 */
.cat-c-badge--brand {
  background: var(--cat-theme-color-background-brand);
  color: var(--cat-theme-color-badge-black-background);
  --cat-theme-badge-dot-background: var(--cat-theme-color-background-brand);
}

/**
 * Orange badge
 */
.cat-c-badge--orange {
  background: var(--cat-theme-color-badge-orange-background);
  --cat-theme-badge-dot-background: var(--cat-theme-color-badge-orange-background);
}

/**
 * Red badge
 */
.cat-c-badge--red {
  background: var(--cat-theme-color-badge-red-background);
  --cat-theme-badge-dot-background: var(--cat-theme-color-badge-red-background);
}

/**
 * contrast badge
 */
.cat-c-badge--contrast {
  background: var(--cat-theme-color-badge-black-background);
  color: var(--cat-theme-color-content-knockout);
  --cat-theme-badge-dot-background: var(--cat-theme-color-badge-black-background);
}

.cat-c-badge--disabled {
  background: var(--cat-theme-color-background-default-disabled);
  color: var(--cat-theme-color-content-disabled);
  border: 1px solid var(--cat-theme-color-background-default-disabled);
  --cat-theme-badge-dot-background: var(--cat-theme-color-background-default-disabled);
  pointer-events: none;
}

/**
 * Badge position
 */
.cat-c-badge--top-left,
.cat-c-badge--top-right {
  position: absolute;
  transform-origin: center center;
  z-index: var(--cat-z-index-400);
  inset-block-start: 0;
}

/**
 * Badge position - top left
 */
.cat-c-badge--top-left {
  inset-inline-end: 100%;
  transform: translate(calc(var(--size-base-unit) * var(--rtlBadgeLeft, 1.5)), calc(-1 * var(--cat-space-small)));
}

/**
 * Badge position - top right
 */
.cat-c-badge--top-right {
  inset-inline-start: 100%;
  transform: translate(calc(var(--size-base-unit) * var(--rtlBadgeRight, -1.5)), calc(-1 * var(--cat-space-small)));
}

/**
 * Badge position with Dots - top left
 */
.cat-is-dot.cat-c-badge--top-left {
  transform: translate(calc(var(--size-base-unit) * var(--rtlBadgeLeft, 1.5) / 2.7), calc(-1 * var(--cat-space-small) / 3.4));
}

/**
 * Badge position with Dots - top right
 */
.cat-is-dot.cat-c-badge--top-right {
  transform: translate(calc(var(--size-base-unit) * var(--rtlBadgeRight, -1.5) / 2.7), calc(-1 * var(--cat-space-small) / 3.4));
}

::slotted(*) {
  padding-inline-end: var(--cat-space-3x-small);
}

.cat-dot-optional-label {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  display: table-cell;
  max-width: var(--cat-badge-label-width, 275px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cat-c-text {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`;
       